// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section___Avg1","not-in-view":"section_not-in-view__DGv75"};